import {useMemo} from 'react';
import {assert} from 'assert-ts';
import {useAppSelector} from 'store/hooks';
import type {Thesaurus, ThesaurusId, ThesaurusesState} from '../types';
import {selectThesaurus} from '../thesaurusSlice';
import {getDummyThesaurus} from './getDummyThesaurus';

export const useThesaurus = (id: ThesaurusId): Thesaurus => {
  const thesaurusState: ThesaurusesState = useAppSelector(selectThesaurus);
  return useMemo(() => {
    const thesaurus = thesaurusState[id]?.data;
    if (
      assert.soft(thesaurus, 'useThesaurus: ThesaurusItem list not loaded', {
        id,
      })
    ) {
      return thesaurus;
    }
    return getDummyThesaurus(id);
  }, [thesaurusState, id]);
};
